// extracted by mini-css-extract-plugin
export default {"root":"PlasmicModuleNavLogo_root__erxSi","buttonNav":"PlasmicModuleNavLogo_buttonNav__BdZ-y","img":"PlasmicModuleNavLogo_img__OuXq-"};